/******
Versione 1.0.20210401
******/

import { FormGroup } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { FormInputService } from '../form-input.service';

@Component({
  selector: 'app-campo-text-area',
  templateUrl: './campo-text-area.component.html',
  styleUrls: ['./campo-text-area.component.scss']
})
export class CampoTextAreaComponent implements OnInit {
  inputClass: string;
  noteClass: string;

  constructor(
    private formComponentsService: FormInputService
    ) {
      this.inputClass = this.formComponentsService.inputClass;
      this.noteClass = this.formComponentsService.noteClass;
  }

  @Input() myForm: FormGroup;
  @Input() config: any;
  @Input() idSuffix: string;

  get objInput() {
    return this.myForm.get(this.config.id);
  }


  ngOnInit(): void {
    if (!this.config.id) {
      this.config.id = 'testo';
    }
    if (this.idSuffix) {
      this.config.id += '_' + this.idSuffix;
    }
    if (!this.config.nome) {
      this.config.nome = 'Testo';
    }
    if (!this.config.numRows) {
      this.config.numRows = 5;
    }
    if (!this.config.maxlength) {
      this.config.maxlength = 0;
    }
  }
}
